package uz.ferro.erp.feature.visit.data

import js.objects.jso
import uz.ferro.erp.feature.excel.ExcelExportUtils
import uz.ferro.erp.feature.visit.model.VisitDto
import uz.ferro.erp.util.formatHMS
import uz.ferro.erp.util.formatInterval
import web.blob.Blob

object ExportVisitsToExcelCase {
    suspend fun exportToExcel(visits: List<VisitDto>): Blob {
        val excel = ExcelExportUtils.exportToExcel(
            sheetName = "Sheet 1",
            head = listOf(
                "ID",
                "Xodim",
                "Mijoz",
                "Tashrif vaqti",
                "Tugallangan vaqti",
                "Davomiyligi"
            ),

            content = visits.map { visit ->
                listOf(
                    visit.id?.toString().orEmpty(),
                    visit.user?.name.orEmpty(),
                    visit.customer?.name.orEmpty(),
                    visit.startTime.formatHMS(),
                    visit.endTime.formatHMS(),
                    formatInterval(visit.startTime, visit.endTime)
                )
            }
        )

        val blob = Blob(arrayOf(excel), jso {
            type = "text/xml"
        })
        return blob
    }
}